

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { VTooltip } from 'v-tooltip'
Vue.directive('tooltip', VTooltip)

@Component({
})
export default class FilterInfo extends Vue {
  @Prop({ type: Object })
  filterGroup!: {}
}
